/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
interface Signature {
  Args: {
    form?: unknown;
    labelName?: unknown;
    placeholder?: unknown;
    propertyName?: unknown;
  };
}

import { service } from "@ember/service";
import Component from "@glimmer/component";
import type SemeiaSessionService from "parog-web/services/session";

export default class PublicCommentComponent extends Component<Signature> {
  @service declare session: SemeiaSessionService;
}
